import React, { useEffect } from 'react';

import useVideoRecording from '../../hooks/useVideoRecording/useVideoRecording';
import Button from '../../components/global/Button';
import useOpenAlert from '../../hooks/useOpenAlert';
import { getSelfieCaptureError } from '../../components/global/selfie-capture/utilities';
import { getErrorString } from '../../util/normalize-errors';
import ContentWrap from '../../components/global/ContentWrap';

const VideoRecording = () => {
  const openAlert = useOpenAlert();
  const {
    cameraPermission,
    loadingDevices,
    getCameraPermission,
    cameraStreamElementRef,
    recording,
    onRecordingStart,
    onRecordingStop,
    recordedVideoData,
  } = useVideoRecording({
    onError: error => {
      openAlert({
        title: 'There was an error while attempting to record your video',
        message: getSelfieCaptureError(error) || getErrorString(error),
      });
    },
  });

  useEffect(() => {
    getCameraPermission();
  }, []);

  const recordedVideoUrl = recordedVideoData?.current?.url;

  return (
    <>
      <ContentWrap>
        <div className="aspect-16-9">
          <div className="wrapper">
            {recordedVideoUrl && !recording && (
              <video
                playsInline
                style={{ width: '100%', height: '100%' }}
                src={recordedVideoUrl}
                controls
              />
            )}

            <video
              playsInline
              autoPlay
              style={{ width: '100%', height: '100%' }}
              ref={cameraStreamElementRef}
              muted
              className={recordedVideoUrl ? 'd-none' : ''}
            />
          </div>
        </div>

        <div className="d-flex mt-3">
          {loadingDevices && <p className="text-center">Loading&hellip;</p>}
          {!loadingDevices && cameraPermission && (
            <Button
              onClick={recording ? onRecordingStop : onRecordingStart}
              className="m-auto"
            >
              {(() => {
                if (recording) {
                  return 'Stop recording...';
                }

                if (recordedVideoUrl) {
                  return 'Re-take video';
                }

                return 'Start Recording...';
              })()}
            </Button>
          )}
        </div>
      </ContentWrap>
    </>
  );
};

export default VideoRecording;
